import { ref } from 'vue';

export function useAsyncAction() {
  const loading = ref(false);

  async function run(
    fn: () => Promise<void>,
    onError?: (err: unknown) => void,
  ) {
    loading.value = true;
    try {
      await fn();
    } catch (err) {
      onError?.(err);
    } finally {
      loading.value = false;
    }
  }

  return { loading, run };
}
